export const FAILURE_REASONS = [
  { value: 'client_absent',       label: 'Client absent'                    },
  { value: 'client_unreachable',  label: 'Client injoignable (appels + SMS)' },
  { value: 'refused_payment',     label: 'Refus de paiement COD'            },
  { value: 'wrong_address',       label: 'Adresse introuvable / incorrecte'  },
  { value: 'refused_package',     label: 'Refus du colis'                   },
  { value: 'damaged_in_transit',  label: 'Colis endommagé en transit'       },
  { value: 'access_denied',       label: 'Accès refusé (immeuble, zone)'    },
  { value: 'postponed_by_client', label: 'Report demandé par le client'     },
  { value: 'other',               label: 'Autre motif'                      },
] as const

export type FailureReason = typeof FAILURE_REASONS[number]['value']
